import {Component, inject, Renderer2} from '@angular/core'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'

@Component({
  selector: 'vmb-dark',
  imports: [
    MatIconButton,
    MatIcon
  ],
  templateUrl: './dark.component.html',
  styleUrl: './dark.component.scss'
})
export class DarkComponent {
  public dark = true

  private renderer = inject(Renderer2)

  public set(): void {
    if (this.dark) {
      this.renderer.removeClass(document.body, 'dark')
      this.dark = false
    } else {
      this.renderer.addClass(document.body, 'dark')
      this.dark = true
    }
  }
}
